<template lang="html">
  <v-card class="px-3 py-3">
    <v-progress-linear :indeterminate="true"></v-progress-linear>
    <h3>Connecting with your Xero Tenant</h3>
  </v-card>
</template>

<script>
import API from '@/api';
import firebase from 'firebase';

export default {
  name: 'XeroAuth',
  props: {
    code: {
      type: String,
    },
    companyId: {
      type: String,
    },
    state: {
      type: String,
    },
  },
  methods: {
    async closeWindow() {
      const dbPath = localStorage.getItem('XeroMessagePath');
      const dbRef = firebase.database().ref(`message_list/${this.companyId}/${dbPath}`);
      await dbRef.set({ refresh: true })
        .then(f => {}, u => console.error('Rejected writing the thing', u))
        .catch(r => console.error('Did not Write the thing [error edition]', r));

      window.close();
    },
  },
  async mounted() {
    try {
      await API.xero.saveAuthentication({
        code: this.code,
        companyId: this.companyId,
        state: this.state,
      });
    } catch (e) {
      console.log('Error in XeroAuth::save ', e);
    } finally {
      this.closeWindow();
    }
  },
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/pages/Companies/XeroAuth.vue